import React from 'react';

import { Route, useHistory, useLocation } from 'react-router-dom';

import { PRICING_ROUTE } from '../../routes';
import usePageStyles from '../../style';
import { LearnerInfo } from '../../types';
import { checkIsIframed } from '../../utils/helpers';
import { useAuth } from '../../utils/hooks';
import { Loader } from '../Loader';
import LoginWithPopupTriggerView from '../LoginWithPopupTriggerView/LoginWithPopupTriggerView';

interface Props {
  path: string | string[];
  exact?: boolean;
  userInfo?: LearnerInfo | null;
  userLoading: boolean;
  withSubscription?: boolean;
  withPrevSubscription?: boolean;
  render: Function;
}

const ProtectedRoute: React.FC<Props> = ({
  path,
  exact = false,
  userInfo,
  userLoading,
  withSubscription = true,
  withPrevSubscription = false,
  render,
}) => {
  const pageClasses = usePageStyles();
  const { isInitialized, isLoading, loginWithRedirect, loginWithPopup } = useAuth();
  const history = useHistory();
  const location = useLocation();

  if (process.env.REACT_APP_MSW) {
    return (
      <Route path={path} exact={exact}>
        {render()}
      </Route>
    );
  }

  if (userLoading || !isInitialized || isLoading) {
    return (
      <div className={pageClasses.container}>
        <Loader />
      </div>
    );
  }

  if (!userInfo) {
    if (checkIsIframed()) {
      return <LoginWithPopupTriggerView handleLogin={loginWithPopup} />;
    } else {
      loginWithRedirect({
        redirectUri: `${location.pathname}${location.search}`,
        isDirectUrl: location.pathname === '/home',
      });
    }
    return null;
  }

  if (
    withPrevSubscription
      ? !(userInfo?.had_subscription || userInfo?.has_subscription)
      : !userInfo?.has_subscription && withSubscription
  ) {
    history.replace(PRICING_ROUTE);
    return null;
  }

  return (
    <Route path={path} exact={exact}>
      {render()}
    </Route>
  );
};

export default ProtectedRoute;
